import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import { SiteClosedGate } from "@/components/SiteClosedGate";
import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Account from "@/pages/Account";
import Contact from "@/pages/Contact";
import FindReplacement from "@/pages/FindReplacement";
import Content from "@/pages/Content";
import Guides from "@/pages/Guides";
import Guide from "@/pages/Guide";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <SiteClosedGate>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/collections/:slug" element={<Collection />} />
                <Route path="/products/:slug" element={<Product />} />
                <Route path="/search" element={<Collection />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/account" element={<Account />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/find-replacement" element={<FindReplacement />} />
                <Route path="/guides" element={<Guides />} />
                <Route path="/guides/:slug" element={<Guide />} />
                <Route path="/about" element={<Content page="about" />} />
                <Route path="/delivery-returns" element={<Content page="delivery" />} />
                <Route path="/faqs" element={<Content page="faqs" />} />
                <Route path="/privacy-policy" element={<Content page="privacy" />} />
                <Route path="/terms" element={<Content page="terms" />} />
                <Route path="/product-images-disclaimer" element={<Content page="imagedisclaimer" />} />
              </Routes>
            </Layout>
            </SiteClosedGate>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
